import type { IconButtonSize, IconButtonType, IconButtonVariant } from 'types';

/**
 * Returns the corresponding spinner size based on the given icon button size.
 */
export const getSpinnerSize = (size: IconButtonSize) => {
  switch (size) {
    case 'tiny':
      return 'small';
    case 'small':
      return 'medium';
    case 'medium':
      return 'medium';
  }
};

/**
 * Determines the spinner variant based on the icon button variant and type,
 * mirroring the regular Button so loading indicators stay legible on every
 * background.
 */
export const getSpinnerVariant = (
  variant: IconButtonVariant,
  type: IconButtonType,
) => {
  if (variant === 'strong' && type === 'filled') {
    return 'strong';
  }
  if (variant === 'inverted' && ['ghost', 'outline'].includes(type)) {
    return 'strong';
  }
  return 'inverted';
};
